import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "navbar navbar-light navbar-expand-lg navigation-clean" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: "#"
}, "Spatial Port CMS", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navcol-1"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Toggle navigation"),
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_5 = { class: "navbar-nav ms-auto" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_8 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Users")
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Stores")
const _hoisted_12 = {
  class: "nav-item dropdown",
  id: "profile-item"
}
const _hoisted_13 = {
  class: "nav-link dropdown-toggle",
  href: "#",
  id: "navbarDropdown",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_14 = {
  class: "dropdown-menu",
  "aria-labelledby": "navbarDropdown"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Profile")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_confirmation_modal = _resolveComponent("confirmation-modal")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", {
          id: "navcol-1",
          class: _normalizeClass(["collapse", {'d-none': !_ctx.authStore.isAuthenticated(), 'navbar-collapse': _ctx.authStore.isAuthenticated()}])
        }, [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", _hoisted_6, [
              _createVNode(_component_router_link, {
                class: "nav-link text-uppercase",
                to: "/"
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ]),
            (_ctx.authStore.isAdmin())
              ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                  _createVNode(_component_router_link, {
                    class: "nav-link text-uppercase",
                    to: "/users"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("li", _hoisted_10, [
              _createVNode(_component_router_link, {
                class: "nav-link text-uppercase",
                to: "/stores"
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_12, [
              _createElementVNode("a", _hoisted_13, _toDisplayString(_ctx.authStore.$state.user?.username), 1),
              _createElementVNode("ul", _hoisted_14, [
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    class: "dropdown-item",
                    to: "/profile"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    href: "#",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onLogout && _ctx.onLogout(...args)), ["prevent"]))
                  }, "Logout")
                ])
              ])
            ])
          ])
        ], 2)
      ])
    ]),
    _createVNode(_component_confirmation_modal),
    _createVNode(_component_router_view)
  ], 64))
}